export enum IconName {
  STAR = 'star',
  EMPTY_STAR = 'empty-star',
  ARROW_RIGHT_CIRCLE = 'arrow-right-circle',
  WARNING_CIRCLE_ICON = 'warning-circle-icon',
  RETRY_ARROWS = 'retry-arrows',
  SUCCESS_CIRCLE = 'success-circle',
  CROSS_CIRCLE = 'cross-circle',
  LOG_OUT = 'log-out',
  SETTINGS = 'settings',
  HELP_CIRCLE = 'help-circle',
  CLOSE = 'close',
  CLOCK_EXPIRED = 'icon-clock-expired',
  SAD_FACE = 'sad-face',
  MAIN_LOGO = 'main-logo',
  LANDING_LOGIN_ARROWHEAD = 'landing-login-arrowhead',
  LANDING_LOGIN_DOOR = 'landing-login-door',
  LANDING_LOGIN_LINE = 'landing-login-line',
  LANDING_LOGOMARK = 'landing-logomark',
  LANDING_OFFLINE_ICON = 'landing-offline-icon',
  LANDING_PLAN_BADGE = 'landing-plan-badge',
  LANDING_PLAN_CHECK = 'landing-plan-check',
  LANDING_PLAN_CROSS_FEATURED = 'landing-plan-cross-featured',
  LANDING_PLAN_CROSS = 'landing-plan-cross',
  LANDING_SOCIAL_FACEBOOK = 'landing-social-facebook',
  LANDING_SOCIAL_INSTAGRAM = 'landing-social-instagram',
  LANDING_SOCIAL_LINKEDIN = 'landing-social-linkedin',
  LANDING_SOCIAL_X = 'landing-social-x',
  LANDING_SOCIAL_YOUTUBE_MARK = 'landing-social-youtube-mark',
  LANDING_SOCIAL_YOUTUBE = 'landing-social-youtube',
  LANDING_STEP_ARROW = 'landing-step-arrow',
}
